/**
 *
 * DraggableCircleMarker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import L from 'leaflet';
import { Marker } from 'react-leaflet';

class DraggableCircleMarker extends React.PureComponent {
  render() {
    const { center, className, ...rest } = this.props;
    const icon = L.divIcon({ className });
    return <Marker {...rest} position={center} icon={icon} />;
  }
}

DraggableCircleMarker.propTypes = {
  center: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default DraggableCircleMarker;
